<template>
    <v-dialog
        v-model="dialog"
        width="500"
        transition="fab-transition"
    >
        <v-card class="pl-0 pr-0">
            <v-card-title>
                <v-icon class="mr-3">fas fa-barcode</v-icon>
                <span class="subtitle-2 font-weight-black">
                    Imprimir código de barras
                </span> 
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="product">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                label="Producto"
                                v-model="description"
                                readonly
                                hide-details
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" style="text-align: center;">
                            <barcode v-model="product.barcode"></barcode>
                        </v-col>
                    </v-row>
                    <!--
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                label="Número de copias"
                                v-model="copies"
                                type="number"
                                hide-details
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    -->
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pt-0">
                <v-container class="pt-0 pb-0">
                    <v-row justify="center">
                        <v-col cols="6">
                            <v-btn dark color="error" block @click="handleCancel">
                                Cancelar
                            </v-btn>
                        </v-col>                      
                        <v-col cols="6">
                            <v-btn dark color="green" block @click="handlePrintBarcode">
                                Aceptar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>                    
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
//import printUtil from '@/plugins/print';
import VueBarcode from '@chenfengyuan/vue-barcode';

import BarcodeTools from '../../helpers/BarcodeTools';

import JQuery from 'jquery';
let $ = JQuery;

export default {
    name: 'PrintBarcode',
    components: {
        'barcode': VueBarcode
    },
    data () {
        return {
            dialog: false,
            product: null,
            description: null,
            copies: 1
        }
    },
    methods: {
        show (product, description) {
            this.clearData();
            this.product = product;
            this.description = description;
            this.dialog = !this.dialog
        },
        clearData () {
            this.product = null;
            this.description = null;
            this.copies = 1;
        },
        handleCancel () {
            this.clearData();
            this.dialog = false;
        },
        /*
        handlePrint () {
            if (this.copies == null || this.copies=='' || parseInt(this.copies) < 1) {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE IMPRESIÓN',
                    text: 'El número de copias dede ser mayor a 1!'
                });
            } else {
                let print = new printUtil()
                print.launch().then(() => {
                    print.printBarcodeProduct(this.product, this.copies);
                });
                this.dialog = false;
            }            
        },
        */
        async handlePrintBarcode () {
            if (this.product) {
                let content = await BarcodeTools.generateContent(this.product);
                this.printBarcode(content);
            }            
        },
        printBarcode (content) {
            $('<iframe>', {name: 'voucheriframe',class: 'printFrame'})
            .appendTo('body')
            .contents().find('body')
            .append(content);

            window.frames['voucheriframe'].focus();
            setTimeout(() => {                 
                window.frames['voucheriframe'].print();
            }, 500);

            setTimeout(() => { $(".printFrame").remove(); }, 1000);
        }
    }
}
</script>

<style scoped>

</style>